import { render, staticRenderFns } from "./data-in-form-tool.vue?vue&type=template&id=9bb2720c&scoped=true&"
import script from "./data-in-form-tool.ts?vue&type=script&lang=ts&"
export * from "./data-in-form-tool.ts?vue&type=script&lang=ts&"
import style0 from "./data-in-form-tool.scss?vue&type=style&index=0&id=9bb2720c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb2720c",
  null
  
)

export default component.exports